import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ArrowRight } from "lucide-react";
import { API } from "@/lib/api";
import TopBar from "@/components/TopBar";

export default function HostSmallTable() {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const create = async (e) => {
    e.preventDefault();
    const trimmed = name.trim().slice(0, 30);
    if (!trimmed) { setError("Thy table needs a name."); return; }
    setBusy(true);
    setError(null);
    try {
      const res = await axios.post(`${API}/tavern-rooms`, { name: trimmed });
      const key = res.data?.key;
      if (!key) throw new Error("No key returned");
      navigate(`/tavern/room/${key}`);
    } catch (err) {
      setBusy(false);
      setError(err?.response?.data?.detail || err?.message || "Failed to set the table.");
    }
  };

  return (
    <div className="relative min-h-screen overflow-hidden flex flex-col" data-testid="host-small-table-page">
      <div className="absolute inset-0 tapestry-grid pointer-events-none opacity-50" />
      <TopBar
        theme="tavern"
        onBack={() => navigate("/tavern")}
        backLabel="Tavern"
        testId="host-small-back-button"
      />
      <div className="relative z-10 max-w-md mx-auto px-6 pt-24 pb-12 w-full">
        <div className="text-center mb-6">
          <h1
            className="font-display text-3xl md:text-4xl font-bold tracking-tight"
            style={{ color: "#E5C870", textShadow: "0 1px 0 rgba(0,0,0,0.7), 0 0 14px rgba(201,162,74,0.5)" }}
          >
            Set Thy Table
          </h1>
          <p className="mt-3 italic font-body text-base" style={{ color: "#E5C870" }}>
            Name a private table. Once 'tis set, share the chamber-key with thy chosen friends.
          </p>
        </div>

        <form onSubmit={create} className="arcade-panel p-6 space-y-5">
          <div>
            <div className="text-[10px] tracking-[0.3em] uppercase text-red-800 mb-2 font-display">
              Table Name
            </div>
            <input
              autoFocus
              value={name}
              onChange={(e) => setName(e.target.value.slice(0, 30))}
              maxLength={30}
              placeholder="Hearth-side Corner"
              className="arcade-input w-full text-base"
              data-testid="host-small-name-input"
            />
            <div className="text-base text-stone-600 mt-1 italic font-mono">{name.length}/30</div>
          </div>
          {error && (
            <div className="text-red-700 text-sm font-mono" data-testid="host-small-error">
              {error}
            </div>
          )}
          <button
            type="submit"
            disabled={busy || !name.trim()}
            className="arcade-btn arcade-btn-magenta w-full !py-3 disabled:opacity-50"
            data-testid="host-small-create-button"
          >
            {busy ? "Setting the table…" : <>Set the Table <ArrowRight size={14} /></>}
          </button>
        </form>
      </div>
    </div>
  );
}
